export default "__VITE_ASSET__DOD5q3JI__"